import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { getToken, base_url } from "../../config/config";

function ProjectSummary() {
  const { ANR } = useParams();
  const [projectData, setProjectData] = useState(null);
  const [workData, setWorkData] = useState([]);

  useEffect(() => {
    console.log("Refreshing table...");
    axios
      .get(`${base_url}/v1/getUserProjectReport/` + ANR)
      .then((response) => {
        if (response.data.status === 1) {
          setWorkData(response.data.data);
        } else {
          console.error("Error fetching API data:", response.data.message);
        }
      })
      .catch((error) => {
        console.error("Error fetching API data:", error);
      });

    axios
      .get(`${base_url}/v1/getSingleProjectReport/` + ANR)
      .then((response) => {
        if (response.data.status === 1) {
          setProjectData(response.data.data);
        } else {
          console.error("Error fetching API data:", response.data.message);
        }
      })
      .catch((error) => {
        console.error("Error fetching API data:", error);
      });
  }, [ANR]);

  const convertTimeToHours = (timeStr) => {
    const [hours, minutes, seconds] = timeStr.split(":").map(Number);
    return hours + minutes / 60 + seconds / 3600;
  };

  const totalWorkCost = workData.reduce((acc, work) => {
    const hoursWorked = convertTimeToHours(work.TotalTime);
    const cost = hoursWorked * parseFloat(projectData?.MengeCost || 0);
    return acc + cost;
  }, 0);

  if (!projectData) {
    return <div>Loading...</div>;
  }

  return (
    <div style={{ margin: 40 }}>
      <h1>Project Report</h1>
      <h2>Project Number: {ANR}</h2>
      <div>
        <h3>Project Details</h3>
        <h1>
          <strong>Total Product Sale Cost:</strong> £
          {parseInt(projectData.singlemengecost) * parseInt(projectData.Menge)}
        </h1>
        <p>
          {" "}
          {"("}Menge X Quantity ={" "}
          {projectData.singlemengecost + " X " + projectData.Menge}
          {")"}
        </p>
        <h1>
          <strong>Total Product Work Cost:</strong> £
          {parseInt(totalWorkCost.toFixed(2)) +
            parseInt(projectData.totalMaterialCost) +
            parseInt(projectData.totalsubcontratorCost)}
        </h1>
        <p>
          {" "}
          {"("}work time + material cost + subcontractor cost ={" "}
          {totalWorkCost.toFixed(2) +
            " + " +
            projectData.totalMaterialCost +
            " + " +
            projectData.totalsubcontratorCost}
          {")"}
        </p>
        <h1>
          <strong>Profit:</strong>{" "}
          <p style={{ color: "green" }}>
            + £
            {parseInt(projectData.singlemengecost) *
              parseInt(projectData.Menge) -
              (parseInt(totalWorkCost.toFixed(2)) +
                parseInt(projectData.totalMaterialCost) +
                parseInt(projectData.totalsubcontratorCost))}
          </p>
        </h1>
        <p>
          <strong>Auftragsbezeichnung:</strong>{" "}
          {projectData.Auftragsbezeichnung}
        </p>
        <p>
          <strong>Baugruppenzeichnung:</strong>{" "}
          {projectData.Baugruppenzeichnung}
        </p>
        <p>
          <strong>Artikelnummer:</strong> {projectData.Artikelnummer}
        </p>
        <p>
          <strong>Status:</strong> {projectData.status}
        </p>
      </div>
      <div>
        <h3>Cost Details</h3>
        <p>
          <strong>Total Material Cost:</strong> £{projectData.totalMaterialCost}
        </p>
        <p>
          <strong>Total Subcontractor Cost:</strong> £
          {projectData.totalsubcontratorCost}
        </p>
        <p>
          <strong>Total Work Cost:</strong> £{totalWorkCost.toFixed(2)}
        </p>
      </div>
      <div>
        <h3>Material Costs</h3>
        <ul>
          {projectData.materialCosts?.map((material, index) => (
            <li key={index}>
              <p>
                <strong>Name:</strong> {material.name || "N/A"}
              </p>
              <p>
                <strong>Description:</strong> {material.description || "N/A"}
              </p>
              <p>
                <strong>Cost:</strong> ${material.cost || "N/A"}
              </p>
            </li>
          ))}
        </ul>
      </div>
      <div>
        <details>
          <summary>Subcontractors</summary>
          <ul>
            {projectData.subcontractors?.map((subcontractor, index) => (
              <li key={index}>
                <p>
                  <strong>Name:</strong> {subcontractor.name}
                </p>
                <p>
                  <strong>Cost:</strong> ${subcontractor.cost}
                </p>
              </li>
            ))}
          </ul>
        </details>
      </div>
      <div>
        <details>
          <summary>Work details</summary>
          <ul>
            {workData?.map((work, index) => (
              <li key={index}>
                <p>
                  <strong>Date:</strong> {work.date}
                </p>
                <p>
                  <strong>User:</strong> {work.user}
                </p>
                <p>
                  <strong>Description:</strong> {work.description}
                </p>
                <p>
                  <strong>Start Time:</strong> {work.StartTime}
                </p>
                <p>
                  <strong>End Time:</strong> {work.EndTime}
                </p>
                <p>
                  <strong>Total Time:</strong> {work.TotalTime}
                </p>
                <p>
                  <strong>Edited Time:</strong> {work.EditedTime}
                </p>
                <p>
                  <strong>ANR:</strong> {work.ANR}
                </p>
                <p>
                  <strong>Menge:</strong> {work.Menge}
                </p>
                <p>
                  <strong>Arbeiten:</strong> {work.Arbeiten}
                </p>
              </li>
            ))}
          </ul>
        </details>
      </div>
    </div>
  );
}

export default ProjectSummary;
